import { Component } from '@angular/core';

import { Platform, MenuController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';

import { AuthenticationService } from './services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private menuCtrl: MenuController,
    private fireAuth: AngularFireAuth,
    public auth: AuthenticationService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.fireAuth.onAuthStateChanged(user => {
        if (user) {
          // User is signed in.
          this.fireAuth.user.subscribe((data) => {
            // Credenciales
            if (data) {
              this.auth.setUserData(data);
              this.router.navigate(['location']);
              this.splashScreen.hide();
            }
          });
        } else {
          this.closeMenu();
          this.router.navigate(['login']);
          this.splashScreen.hide();
        }
      });
      this.statusBar.styleDefault();
      this.checkDarkTheme();
    });
  }

  checkDarkTheme() {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    if ( prefersDark.matches ) {
        document.body.classList.toggle( 'dark' );
    }
  }

  async closeMenu() {
    if (await this.menuCtrl.isOpen()) {
      await this.menuCtrl.close();
      await this.menuCtrl.enable(false, 'primerMenu');
    }
  }
}
